import { PostMediaType } from '@getaccept/dsr-shared-new/src/types/enums/post-media-type';
import type { PostMedia } from '@getaccept/dsr-shared-new/src/types/post';
import { ImageService } from '../../image/service/image.service';
import { VideoService } from '../../video/service/video.service';

export class MediaService {
  static async loadMediaUrl(media: PostMedia) {
    return media.type === PostMediaType.Image
      ? await ImageService.load(media.imageId)
      : await VideoService.load(media.videoId);
  }

  static async loadMediaUrls(media: PostMedia[]) {
    const promises = media.map(async item => ({
      ...item,
      url: await MediaService.loadMediaUrl(item),
    }));
    return await Promise.all(promises);
  }
}
